var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 10,
    fill: "white",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 37.4,
    height: 37.4,
    rx: 9.7,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7290_200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.167 19.0003C18.167 19.2213 18.2548 19.4333 18.4111 19.5896C18.5674 19.7459 18.7793 19.8337 19.0003 19.8337C19.2213 19.8337 19.4333 19.7459 19.5896 19.5896C19.7459 19.4333 19.8337 19.2213 19.8337 19.0003C19.8337 18.7793 19.7459 18.5674 19.5896 18.4111C19.4333 18.2548 19.2213 18.167 19.0003 18.167C18.7793 18.167 18.5674 18.2548 18.4111 18.4111C18.2548 18.5674 18.167 18.7793 18.167 19.0003Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.167 24.8333C18.167 25.0543 18.2548 25.2663 18.4111 25.4226C18.5674 25.5789 18.7793 25.6667 19.0003 25.6667C19.2213 25.6667 19.4333 25.5789 19.5896 25.4226C19.7459 25.2663 19.8337 25.0543 19.8337 24.8333C19.8337 24.6123 19.7459 24.4004 19.5896 24.2441C19.4333 24.0878 19.2213 24 19.0003 24C18.7793 24 18.5674 24.0878 18.4111 24.2441C18.2548 24.4004 18.167 24.6123 18.167 24.8333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.167 13.1663C18.167 13.3874 18.2548 13.5993 18.4111 13.7556C18.5674 13.9119 18.7793 13.9997 19.0003 13.9997C19.2213 13.9997 19.4333 13.9119 19.5896 13.7556C19.7459 13.5993 19.8337 13.3874 19.8337 13.1663C19.8337 12.9453 19.7459 12.7334 19.5896 12.5771C19.4333 12.4208 19.2213 12.333 19.0003 12.333C18.7793 12.333 18.5674 12.4208 18.4111 12.5771C18.2548 12.7334 18.167 12.9453 18.167 13.1663Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7290_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownDots);
export default __webpack_public_path__ + "static/media/dropdown_dots.2299479b0a3fbca751a0c0da3e1b1411.svg";
export { ForwardRef as ReactComponent };